import { CSSObject } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import { TAvailableTypographyVariants } from "@ob/theme";

export const fontSizes = {
  none: "0px",
  xxs: "12px",
  xs: "14px",
  s: "16px",
  m: "18px",
  l: "24px",
  xl: "30px",
  xxl: "36px",
};

export const lineHeights = {
  xs: "16px",
  s: "24px",
  m: "32px",
  l: "40px",
  xl: "48px",
};

export const fontWeights = {
  xs: 300,
  s: 400,
  m: 500,
  l: 600,
  xl: 700,
};

export const typographyVariants: Record<
  TAvailableTypographyVariants,
  CSSObject & {
    component: string;
  }
> = {
  headingXLarge: {
    component: "h1",
    fontFamily: "App",
    fontSize: fontSizes.xxl,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.xl,
  },
  headingLarge: {
    component: "h1",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.xl,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.l,
  },
  headingMedium: {
    component: "h3",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.l,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.m,
  },
  subtitle: {
    component: "h4",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.m,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
  },
  body: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.s,
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
    "strong, b": {
      fontWeight: fontWeights.m,
    },
  },
  bodyMedium: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.s,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
    "strong, b": {
      fontWeight: fontWeights.m,
    },
  },
  bodyBold: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.s,
    fontWeight: fontWeights.xl,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
  },
  small: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.xs,
    fontWeight: fontWeights.s,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
  },
  smallMedium: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.xs,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
  },
  xsmall: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.xxs,
    fontWeight: fontWeights.m,
    letterSpacing: 0,
    lineHeight: lineHeights.xs,
  },
  disclaimer: {
    component: "p",
    fontFamily: "AppMainFont",
    fontSize: fontSizes.xs,
    fontWeight: fontWeights.s,
    letterSpacing: 0,
    lineHeight: lineHeights.s,
    "strong, b": {
      fontWeight: fontWeights.m,
    },
  },
};

export const typography: TypographyOptions = {
  fontFamily: "AppMainFont",
  ...typographyVariants,
  body1: undefined,
  body2: undefined,
  button: undefined,
  caption: undefined,
  h1: undefined,
  h2: undefined,
  h3: undefined,
  h4: undefined,
  h5: undefined,
  h6: undefined,
  subtitle1: undefined,
  subtitle2: undefined,
  overline: undefined,
};
